import {
  fetchpost,fetchposts, fetchget, fetch, fetchapi, baseUrl,baseUrl2, userlist, registeruser, editaccounuser, brandspavilion, brandsvisible, bannerlist, uploadimg, banneredit, onetypelist, onetypeadd, onetypedelete, onetypeedit,
  twotypelist, twotypedelete, twotypeadd, twotypeedit, getsection, getClassification, goodsadd, classificationlist, getplatearealist, companylist, companybrandsdet, brandsclist,
  pushwideinfor, brandsadd, brandsedit, getmaingoodlist, getbrandgoodlist, getnews, addnews, delnews, companyedit, delcategorygoods, delsectiongoods, delmaingoods,
  getgoodsdetail, goodsedit, goodsdel, thirdtypelist, thirdtypeedit, thirdtypeadd, thirdtypedelete, accountlist, accountadd, accountedit, accountdet, getgoodstype, getallgoods, sectiongoodsadd,
  sectiongoodsedit, sectiongoodsdel, sectiongoodsget, hotcompanyget, hotcompanyadd, hotcompanyedit, hotcompanydel, headlinesget, headlinesadd, headlinesedit, headlinesdel, spikeget,
  spikeadd, spikeedit, categorygoods, categoryadd, categoryedit, categorydel, getbrandnews, delbrandnews, getbrandgoods, editbrandgoods, addbrandgoods, delbrandgoods, brandgethotbrand,
  brandaddhotbrand, brandedithotbrand, branddelhotbrand, topgoodsget, topgoodsedit, topgoodsadd, topgoodsdel, brandhallgetbanner, brandhalleditbanner, getallbrandlist, getbrandhall,
  editbrandhall, addbrandhall, delbrandhall, shopstreetget, shopstreetadd, shopstreetedit, shopstreetdel, shopstreetgetbanner, shopstreeteditbanner, hotgoodsget, hotgoodsadd,
  hotgoodsedit, hotgoodsdel, hotgoodsgetbanner, hotgoodseditbanner, getnonegoods, getbusinesstype, getshoplist, editdetail, editstatus, companyadd, orderall, classgetbanner, classeditbanner,
  paysendorder, logistics

} from 'config/index.js'
/**
 * 会员登陆
 * @param params
 * @returns {*}
 */
export function loginUserNo(params) {
  return fetch(`${baseUrl}/api/declare/login?userName=${params.userName}&password=${params.password}`, params)
}

/*厂家管理*/
//获取验证码
export function loginSm(params) {
  return fetchpost(`${baseUrl}/login/sm`, params)
}

//官网news
export function getNewsList(params) {
  return fetchposts(`https://slb.zhaomeiw.com/osNews/getList`, params)
}

// export function getNewsList(params) {
//   return fetchposts(`${baseUrl}/osNews/getList`, params)
// }



// WEBPACK FOOTER //
// ./src/api/common.js